import { useEffect, useState } from 'react';
import {
    PanelBody,
    Button,
    Modal,
    TextControl,
    SelectControl,
    TextareaControl,
    CheckboxControl,
    RadioControl,
    Spinner,
    __experimentalNumberControl as NumberControl,
    Flex,
    FlexItem,
    FlexBlock,
    FormToggle
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { fetchData, saveData } from './api';

const PostTab = ({ openPopup, setActiveTab  }) => {
    const [isSaving, setIsSaving] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [modifiedFields, setModifiedFields] = useState({});
     const [hideshowFields, setHideshowFields] = useState([
        { key: 'title', label: 'Title' },
        { key: 'images', label: 'Images' },
        { key: 'short_desc', label: 'Short Description' },
        { key: 'long_desc', label: 'Long Description' },
        { key: 'read_more', label: 'Read More' },
    ]);
    useEffect(() => {
        // Fetch settings from the REST API
        fetchData(gmwcp_wp_ajax.getsettings, gmwcp_wp_ajax.nonce)
            .then((fetchedData) => {
                setData(fetchedData);
                setLoading(false);
                const newFields = [
                    ...fetchedData.custom_fields.map((field) => ({
                        key: field.gmwcpkey, // Assuming 'field' has a key property
                        label: field.title, // Assuming 'field' has a label property
                    }))
                ];
                // Update state with new fields
                setHideshowFields((prevFields) => [...prevFields, ...newFields]);
            })
            .catch((error) => {
                setLoading(false);
                console.error('Error fetching settings:', error);
            });
    }, []);

    const updateField = (field, value) => {
        setData((prevData) => ({
            ...prevData,
            [field]: value,
        }));
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [field]: value,
        }));
    };
    const toggleCheckbox = (fieldName, key) => {
        setData((prevData) => {
            const currentValues = prevData[fieldName] || [];
            const updatedValues = currentValues.includes(key)
                ? currentValues.filter((item) => item !== key) // Remove key if already present
                : [...currentValues, key]; // Add key if not present
            return {
                ...prevData,
                [fieldName]: updatedValues,
            };
        });
        setModifiedFields((prevFields) => ({
            ...prevFields,
            [fieldName]: data[fieldName]?.includes(key)
                ? data[fieldName].filter((item) => item !== key)
                : [...(data[fieldName] || []), key],
        }));
    };

    const saveSettings = () => {
        if (Object.keys(modifiedFields).length === 0) {
            openPopup('No changes to save.');
            return;
        }
        setIsSaving(true);

        saveData(gmwcp_wp_ajax.savedata, gmwcp_wp_ajax.nonce, modifiedFields)
            .then((responseData) => {
                setIsSaving(false);
                if (responseData.success) {
                    openPopup('Settings saved!');
                    setModifiedFields({});
                } else {
                    openPopup('Failed to save settings.');
                }
            })
            .catch((error) => {
                setIsSaving(false);
                console.error('Error saving settings:', error);
                openPopup('Failed to save settings.');
            });
    };
    
    return (
        <PanelBody>
             {loading ? (
                <Spinner />
            ) : (
                <>
                        <table className="GMadminTable">
                            <tr>
                                <th>
                                    <label>Enable Single Product Page</label>
                                </th>
                                <td>
                                    <FormToggle
                                      checked={data.gmptp_enable_single_product === 'yes'}
                                      onChange={() =>
                                            updateField('gmptp_enable_single_product', data.gmptp_enable_single_product === 'yes' ? 'no' : 'yes')
                                        }
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Enable Post Type</label>
                                </th>
                                <td>
                                   {data.get_post_types.map(({ name, label }) => (
                                        <CheckboxControl
                                            key={name}
                                            label={label}
                                            checked={data.gmptp_shop_post?.includes(name)} // Check if name exists in the array
                                            onChange={() => toggleCheckbox('gmptp_shop_post', name)} // Toggle with correct field
                                        />
                                    ))}

                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Show/Hide Options</label>
                                </th>
                                <td>
                                   {hideshowFields.map(({ key, label }) => (
                                        <CheckboxControl
                                            key={key}
                                            label={label}
                                            checked={data.gmptp_show_hide?.includes(key)} // Check if key exists in array
                                            onChange={() => toggleCheckbox('gmptp_show_hide', key)} // Pass field name and key dynamically
                                        />
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    <label>Display Location</label>
                                </th>
                                <td>
                                    <RadioControl
                                    selected={data.gmptp_single_display_location}
                                    options={ [
                                        { label: 'Before Content', value: 'before_content' },
                                        { label: 'After Content', value: 'after_content' },
                                        { label: 'Custom Location', value: 'custom' },
                                    ] }
                                    onChange={(value) => updateField('gmptp_single_display_location', value)}
                                   
                                />
                                </td>
                            </tr>
                        </table>
                        <h4>Custom Location for you need to use shortcode  <code>[gmptp_single_post]</code> or <code>[gmptp_single_post id="post_id"]</code></h4>
                        <Button isPrimary onClick={saveSettings} disabled={isSaving}>
                            {isSaving ? <Spinner /> : 'Save Settings'}
                        </Button>
                      </>
            )}
        </PanelBody>
    );
};

export default PostTab;
